/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CodeTableType
 *
 * @class CodeTableType
 */
class CodeTableType {
  /**
   * Creates an instance of CodeTableType.
   * @param {*} json
   * @memberof CodeTableType
   */
  constructor(json = null) {
    if (json) {
      // string
      this.tableName = json.tableName;

      // string
      this.value = json.value;

      // string
      this.description = json.description;

      // string
      this.parentCodeTable = json.parentCodeTable;
    }
  }
}

/**
 * Models the SDSurveyOptionStruct
 *
 * @class SDSurveyOptionStruct
 */
class SDSurveyOptionStruct {
  /**
   * Creates an instance of SDSurveyOptionStruct.
   * @param {*} json
   * @memberof SDSurveyOptionStruct
   */
  constructor(json = null) {
    if (json) {
      // string
      this.optionCode = json.optionCode;

      // string
      this.optionText = json.optionText;
    }
  }
}

/**
 * Models the SDSurveyQuestionStruct
 *
 * @class SDSurveyQuestionStruct
 */
class SDSurveyQuestionStruct {
  /**
   * Creates an instance of SDSurveyQuestionStruct.
   * @param {*} json
   * @memberof SDSurveyQuestionStruct
   */
  constructor(json = null) {
    if (json) {
      // object - CodeTableType
      if (json.questionCode) {
        this.questionCode = new CodeTableType(json.questionCode);
      }

      // string
      this.questionText = json.questionText;

      // integer
      this.questionOrder = json.questionOrder;

      // array - SDSurveyOptionStruct
      if (json.options) {
        this.options = json.options.map(object => new SDSurveyOptionStruct(object));
      } else if (json.constructor === Array) {
        this.options = json.map(object => new SDSurveyOptionStruct(object));
      }
    }
  }
}

/**
 * Models the SDSurveyQuestionOptionsResponseStruct
 *
 * @class SDSurveyQuestionOptionsResponseStruct
 */
class SDSurveyQuestionOptionsResponseStruct {
  /**
   * Creates an instance of SDSurveyQuestionOptionsResponseStruct.
   * @param {*} json
   * @memberof SDSurveyQuestionOptionsResponseStruct
   */
  constructor(json = null) {
    if (json) {
      // array - SDSurveyQuestionStruct
      if (json.questions) {
        this.questions = json.questions.map(object => new SDSurveyQuestionStruct(object));
      } else if (json.constructor === Array) {
        this.questions = json.map(object => new SDSurveyQuestionStruct(object));
      }
    }
  }
}

/**
 * Models the NewSDSurveyQuestionAnswerStruct
 *
 * @class NewSDSurveyQuestionAnswerStruct
 */
class NewSDSurveyQuestionAnswerStruct {
  /**
   * Creates an instance of NewSDSurveyQuestionAnswerStruct.
   * @param {*} json
   * @memberof NewSDSurveyQuestionAnswerStruct
   */
  constructor(json = null) {
    if (json) {
      // string
      this.questionCode = json.questionCode;

      // string
      this.answer = json.answer;
    }
  }
}

/**
 * Models the NewSDPostSurveyAnswersStruct
 *
 * @class NewSDPostSurveyAnswersStruct
 */
class NewSDPostSurveyAnswersStruct {
  /**
   * Creates an instance of NewSDPostSurveyAnswersStruct.
   * @param {*} json
   * @memberof NewSDPostSurveyAnswersStruct
   */
  constructor(json = null) {
    if (json) {
      // string
      this.applicationId = json.applicationId;

      // array - NewSDSurveyQuestionAnswerStruct
      if (json.answers) {
        this.answers = json.answers.map(object => new NewSDSurveyQuestionAnswerStruct(object));
      } else if (json.constructor === Array) {
        this.answers = json.map(object => new NewSDSurveyQuestionAnswerStruct(object));
      }
    }
  }
}

export default {
  CodeTableType,

  SDSurveyOptionStruct,

  SDSurveyQuestionStruct,

  SDSurveyQuestionOptionsResponseStruct,

  NewSDSurveyQuestionAnswerStruct,

  NewSDPostSurveyAnswersStruct,
};
